<!-- src/app/pages/faq/faq.component.html -->

<section class="faq-page">
  <div class="container">

    <div class="hero">
      <p class="hero-eyebrow">
        Lydia Christensen • Michigan • U.S. Senate • 2026
      </p>

      <h1>Frequently Asked Questions</h1>

      <p class="hero-sub">
        Frequently asked questions about Lydia Christensen, her campaign
        for the United States Senate in Michigan, how to get involved,
        and where to find more information.
      </p>
    </div>


    <div class="faq-sections">

      <div
        *ngFor="let section of sections"
        class="faq-section"
      >

        <h2 class="faq-section__heading">
          {{ section.heading }}
        </h2>

        <div class="faq-list">

          <div
            *ngFor="let item of section.items"
            class="faq-item"
            [class.faq-item--open]="item.open"
          >

            <button
              class="faq-item__question"
              (click)="toggle(section, item)"
              [attr.aria-expanded]="item.open"
            >
              <span>
                {{ item.question }}
              </span>

              <span class="faq-item__chevron">
                {{ item.open ? '▲' : '▼' }}
              </span>
            </button>

            <div
              class="faq-item__answer"
              *ngIf="item.open"
            >
              <p>
                {{ item.answer }}
              </p>
            </div>

          </div>

        </div>

      </div>

    </div>


    <div class="faq-cta">

      <h2>
        Still have questions?
      </h2>

      <p>
        Our team is happy to help. Reach out directly to the campaign.
      </p>

      <div class="faq-cta__buttons">

        <a
          routerLink="/contact"
          class="btn-primary"
        >
          Contact Us
        </a>

        <a
          href="https://discord.gg/DNqwMBsycY"
          target="_blank"
          rel="noopener noreferrer"
          class="btn-secondary"
        >
          Join Discord
        </a>

      </div>

    </div>

  </div>
</section>